import {
  createFrontendModule,
  Progress,
  NotFoundErrorPage,
  ErrorDisplay,
} from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';

export const swappableComponentsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SwappableComponentBlueprint.make({
      name: 'kpc-progress',
      params: define =>
        define({
          component: Progress,
          loader: () =>
            import('./progress').then(m => m.KpcProgress),
        }),
    }),
    SwappableComponentBlueprint.make({
      name: 'kpc-not-found',
      params: define =>
        define({
          component: NotFoundErrorPage,
          loader: () =>
            import('./not-found').then(m => m.KpcNotFound),
        }),
    }),
    SwappableComponentBlueprint.make({
      name: 'kpc-error-display',
      params: define =>
        define({
          component: ErrorDisplay,
          loader: () =>
            import('./error-display').then(m => m.KpcErrorDisplay),
        }),
    }),
  ],
});
